import { z } from "zod";

const portSchema = z.coerce.number().int().positive().optional().catch(undefined);

export interface CreateURLParams {
	/**
	 * The protocol to use for the URL.
	 *
	 * @default "http"
	 */
	protocol?: "WS" | "HTTP";

	/**
	 * Secure protocol flag.
	 * Uses "wss" for protocol="ws" and "https" for protocol="http".
	 *
	 * @default true
	 */
	secure?: boolean;

	host: string;

	/**
	 * Optional port number for the URL.
	 */
	port?: string | number;

	/**
	 * Optional path to append to the URL.
	 */
	path?: string;
}

export function createURL({ protocol = "HTTP", secure = true, host, port, path = "" }: CreateURLParams): string {
	const trimmedPath = path.trim();
	const decodedPort = portSchema.parse(port);

	return [
		protocol.toLowerCase(),
		secure ? "s:" : ":",
		"//",
		host,
		decodedPort ? `:${decodedPort}` : "",
		trimmedPath ? `/${trimmedPath.replace(/^\/+/u, "")}` : "",
	].join("");
}
